import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import {
  type UploadPdfToAiProjectArguments,
  type UploadPdfToAiProjectResponse,
} from './types';
import { uploadPdfToAiProject } from './uploadPdfFileToAiProject';

/**
 * React Query mutation hook for uploading a PDF file to an AI project.
 * @param options - Optional mutation options (excluding mutationFn)
 * @returns A mutation object containing the upload function and status
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/upload_pdf_to_blob_upload_pdf_to_blob_post
 */
export const useMutationUploadPdfToAiProject = (
  options?: Omit<
    UseMutationOptions<
      UploadPdfToAiProjectResponse,
      Error,
      UploadPdfToAiProjectArguments
    >,
    'mutationFn'
  >,
) => {
  return useMutation({
    mutationFn: async ({
      pdfFile,
      projectName,
    }: UploadPdfToAiProjectArguments) =>
      uploadPdfToAiProject({
        pdfFile,
        projectName,
      }),
    ...options,
  });
};
